import { get } from './client.js';

/* SA-only platform analytics */
export const getOverview = () => get('/platform/analytics/overview');
export const getGrowth = () => get('/platform/analytics/org-growth');
export const getChurn = () => get('/platform/analytics/churn');       /* no backend — Future Work */
export const getRevenue = () => get('/platform/analytics/revenue');   /* no backend — Future Work */

/* Org-scoped analytics (OA) */
const qs = (params) => params ? '?' + new URLSearchParams(params).toString() : '';
export const getOrgOverview           = (orgId)         => get(`/orgs/${orgId}/analytics`);
export const getOrgGrowth             = (orgId)         => get(`/orgs/${orgId}/analytics/user-growth`);
export const getOrgWorkspaceActivity  = (orgId, params) => get(`/orgs/${orgId}/analytics/workspace-activity${qs(params)}`);
export const getOrgMemberActivity     = (orgId, params) => get(`/orgs/${orgId}/analytics/member-activity${qs(params)}`);
export const getOrgDeals              = (orgId, params) => get(`/orgs/${orgId}/analytics/deals${qs(params)}`);
export const getOrgStorageTrend       = (orgId)         => get(`/orgs/${orgId}/analytics/storage-trend`);
export const getOrgActivity           = (orgId)         => get(`/orgs/${orgId}/analytics/activity`);     /* no backend — Phase 3 */
export const getOrgRetention          = (orgId)         => get(`/orgs/${orgId}/analytics/retention`);    /* no backend — Phase 3 */

/* Platform-scoped license/partner/audit data (SA-only) */
export const getLicenses = (params) => {
  const q = params ? '?' + new URLSearchParams(params).toString() : '';
  return get(`/platform/licenses${q}`);
};

export const getPartners = (params) => {
  const q = params ? '?' + new URLSearchParams(params).toString() : '';
  return get(`/platform/partners${q}`);
};

export const getAudit = (params) => {
  const q = params ? '?' + new URLSearchParams(params).toString() : '';
  return get(`/platform/audit${q}`);
};
